export const Logo = ({ className = 'w-6 h-6' }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <rect x="0" y="0" width="32" height="32" rx="8" fill="hsl(var(--ink))" />
    <path
      d="M18 6 L11 18 H15.5 L14 26 L21 14 H16.5 L18 6 Z"
      fill="hsl(var(--paper))"
    />
  </svg>
);
export default Logo;
